import styled from 'styled-components'

export const Article = styled.article`
  width: 512px;
  margin: 56px auto 170px auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  & h2 {
    color: #424242;
    font-size: 56px;
    font-weight: 300;
    letter-spacing: -0.8px;
    line-height: 56px;
    text-align: center;
    text-shadow: 2px 2px 0 #E0E0E0;
    margin-bottom: 28px;
    text-transform: uppercase;
    font-family: 'DINWebPro Light', 'Open Sans', sans-serif;
  }

  & .subheader {
    color: #050505;
    font-family: 'DINWebPro', 'Open Sans', sans-serif;
    font-size: 21px;
    letter-spacing: -0.2px;
    line-height: 28px;
    text-align: center;
    margin-bottom: 28px;
  }

  @media (max-width: 600px) {
    width: 100%;
    margin: 0 0 65px 0;
    padding: 14px;
    flex-grow: 1;

    & h2 {
      margin: 14px 0;
      font-size: 28px;
      font-weight: 300;
      letter-spacing: -0.4px;
      line-height: 28px;
      text-shadow: 1px 1px 0 #E0E0E0;
    }

    & .subheader {
      font-size: 14px;
      letter-spacing: -0.13px;
      line-height: 21px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Article/Article.js